import { useState, useEffect, useRef } from 'react';
import {
  DeliveryStatusResponse,
  getDeliveryStatus
} from '../api/getDeliveryStatus';
import { getCaseStatus } from 'src/api/getCaseStatus';

export const useDeliveryStatus = ({
  deliveryID
}: {
  deliveryID: string;
}): { deliveryStatus: DeliveryStatusResponse | null; caseStatus: any } => {
  const [deliveryStatus, setDeliveryStatus] =
    useState<DeliveryStatusResponse | null>(null);
  const [caseStatus, setCaseStatus] = useState<any>(null);
  const isFetchingDeliveryRef = useRef(false);
  const isFetchingCaseRef = useRef(false);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!deliveryID || isFetchingDeliveryRef.current) {
        return;
      }

      isFetchingDeliveryRef.current = true;
      try {
        console.log('Fetching delivery status for', deliveryID);
        const result = await getDeliveryStatus({ deliveryID });
        if (result) {
          setDeliveryStatus(result);
        } else {
          setDeliveryStatus(null);
        }
      } catch (error) {
        setDeliveryStatus(null);
      } finally {
        isFetchingDeliveryRef.current = false;
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 1000);

    return () => clearInterval(interval);
  }, [deliveryID]);

  useEffect(() => {
    const fetchCaseStatus = async () => {
      if (!deliveryStatus?.case_id || isFetchingCaseRef.current) {
        return;
      }

      isFetchingCaseRef.current = true;
      try {
        const newCaseStatus = await getCaseStatus({
          uuid: deliveryStatus.case_id
        });

        if (newCaseStatus && newCaseStatus.state) {
          setCaseStatus(newCaseStatus);
        }
      } catch (e) {
        //
      } finally {
        isFetchingCaseRef.current = false;
      }
    };

    fetchCaseStatus();
    const interval = setInterval(fetchCaseStatus, 6000);

    return () => clearInterval(interval);
  }, [deliveryStatus?.case_id]);

  return { deliveryStatus, caseStatus };
};
